  import React, { useState, useEffect } from "react";
  import Index from "../AirSearch/Index"

  const AuthPage = ({ onLoginSuccess, onClose }) => { 
    // ✅ Always have a working close handler, even if parent didn't pass onClose
    const handleClose = onClose
      ? onClose
      : () => {
          if (window.history.length > 1) {
            window.history.back();
          } else {
            console.warn("AuthPage: no onClose prop provided and no history to go back to.");
          }
        };

    const [isActive, setIsActive] = useState(false);
    const [apiMessage, setApiMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState(false); 
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [loginFailed, setLoginFailed] = useState(false);
    
    const [userData, setUserData] = useState(null); 
    const [showDropdown, setShowDropdown] = useState(false);

    // ✅ NEW: logout confirmation popup state
    const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

    const [regName, setRegName] = useState("");
    const [regEmail, setRegEmail] = useState("");
    const [regMobile, setRegMobile] = useState("");
    const [regPassword, setRegPassword] = useState("");
    const [isRegistering, setIsRegistering] = useState(false);
    const [regFailed, setRegFailed] = useState(false);
    const [regSuccess, setRegSuccess] = useState(false);
    const [regMessage, setRegMessage] = useState("");

    // ✅ FIX: Do NOT auto-restore login from localStorage on mount.
    // Previously, stale userData/userKey left in localStorage after a refresh
    // was being treated as "still logged in". Now, on every fresh mount
    // (i.e. every page refresh) we explicitly clear stale login data unless
    // a valid explicit "keepLoggedIn" flag exists.
    useEffect(() => {
      const keepLoggedIn = localStorage.getItem("keepLoggedIn");
      if (keepLoggedIn === "true") {
        const savedUser = localStorage.getItem("userData");
        if (savedUser) {
          try {
            const parsed = JSON.parse(savedUser);
            setUserData(parsed);
            setIsSuccess(true);
          } catch {
            localStorage.removeItem("userKey");
            localStorage.removeItem("userData");
            localStorage.removeItem("keepLoggedIn");
          }
        }
      } else {
        // No explicit "keep me logged in" flag → always require fresh login after refresh
        localStorage.removeItem("userKey");
        localStorage.removeItem("userData");
      }
    }, []);

    const handleLogin = async (e) => {
      e.preventDefault();
      setApiMessage(""); 
      setLoginFailed(false);
      setIsLoading(true);

      const payload = {
        AgencyCode: null,
        UserEmail: email,
        UserName: null,
        LastName: null,
        DOB: null,
        UserMobile: null,
        UserPassword: password,
        UserKey: null,
        UserStatus: null,
        ApiStatus: 0,
        ApiMessage: null,
        ApiResponse: null,
        ApiErro: null,
        AgencyKey: "4AC0F2DD-66C2-4AC1-8AFD-DE615E223A4A",
        AccountNo: 17
      };

      try {
        const apiUrl = process.env.REACT_APP_API_LOGIN_URL;

        if (!apiUrl) {
          throw new Error("API URL missing! Please check your .env file and restart terminal.");
        }

        console.log("🔐 Login Request URL:", apiUrl);
        console.log("📨 Sending Payload:", JSON.stringify(payload, null, 2));

        const response = await fetch(apiUrl, {
          method: "POST",
          headers: { 
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify(payload),
        });

        console.log("📥 Response Status:", response.status);

        if (!response.ok) {
          throw new Error(`HTTP Error: ${response.status}`);
        }

        const data = await response.json();
        console.log("✅ API Response Complete:", JSON.stringify(data, null, 2));

        if (data && data.UserStatus === "Valid" && data.UserKey) {
           await new Promise((resolve) => setTimeout(resolve, 2500));
          setIsSuccess(true);
          setUserData(data); 
          setApiMessage("✅ Login Successful!");

          // ✅ Persist session AND mark that refresh should restore it,
          // until the user explicitly logs out.
          localStorage.setItem("userKey", data.UserKey);
          localStorage.setItem("userData", JSON.stringify(data));
          localStorage.setItem("keepLoggedIn", "true");

          console.log("✅ LOGIN SUCCESS:", data);

          if (onLoginSuccess) {
            onLoginSuccess(data);
          }
        } else {
          setIsSuccess(false);
          setLoginFailed(true);
          
          let errorMsg = "Sorry your Email or Password is incorrect";
          
          if (data?.ApiMessage) {
            errorMsg = data.ApiMessage;
          } else if (data?.message) {
            errorMsg = data.message;
          } else if (data?.error) {
            errorMsg = data.error;
          }
          
          setApiMessage("❌ " + errorMsg);
          console.error("❌ LOGIN FAILED:", {
            userStatus: data?.UserStatus,
            userKey: data?.UserKey,
            apiMessage: data?.ApiMessage,
            fullResponse: data
          });
        }
      } catch (error) {
        console.error("❌ FETCH ERROR:", error.message);
        setIsSuccess(false);
        setLoginFailed(true);

        if (error.message.includes("Failed to fetch")) {
          setApiMessage("❌ Network error! Check your internet connection.");
        } else if (error.message.includes("HTTP")) {
          setApiMessage(`❌ Server error: ${error.message}`);
        } else {
          setApiMessage("❌ " + error.message);
        }
      } finally {
        setIsLoading(false);
      }
    };

    const handleRegister = async (e) => {
      e.preventDefault();
      setRegMessage("");
      setRegFailed(false);
      setRegSuccess(false);
      setIsRegistering(true);

      const payload = {
        UserEmail: regEmail,
        UserName: regName,
        UserMobile: regMobile,
        UserPassword: regPassword,
        AgencyKey: "4AC0F2DD-66C2-4AC1-8AFD-DE615E223A4A",
        AccountNo: 17
      };

      try {
        const apiUrl = "https://api.livev1.fly24hrs.com/api/Accounts/UserAdd";

        console.log("📝 Register Request URL:", apiUrl);
        console.log("📨 Sending Payload:", JSON.stringify(payload, null, 2));

        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify(payload),
        });

        console.log("📥 Response Status:", response.status);

        if (!response.ok) {
          throw new Error(`HTTP Error: ${response.status}`);
        }

        const data = await response.json();
        console.log("✅ API Response Complete:", JSON.stringify(data, null, 2));

        if (data && (data.ApiStatus === 1 || data.UserStatus === "Valid" || data.ApiStatus === undefined)) {
          setRegSuccess(true);
          setRegMessage("✅ Registration Successful! You can now login.");
          console.log("✅ REGISTER SUCCESS:", data);

          setRegName("");
          setRegEmail("");
          setRegMobile("");
          setRegPassword("");

          setTimeout(() => {
            setIsActive(false);
            setRegSuccess(false);
            setRegMessage("");
          }, 1500);
        } else {
          setRegFailed(true);
          let errorMsg = "Registration failed. Please try again.";
          if (data?.ApiMessage) {
            errorMsg = data.ApiMessage;
          } else if (data?.message) {
            errorMsg = data.message;
          } else if (data?.error) {
            errorMsg = data.error;
          }
          setRegMessage("❌ " + errorMsg);
          console.error("❌ REGISTER FAILED:", data);
        }
      } catch (error) {
        console.error("❌ FETCH ERROR:", error.message);
        setRegFailed(true);
        if (error.message.includes("Failed to fetch")) {
          setRegMessage("❌ Network error! Check your internet connection.");
        } else if (error.message.includes("HTTP")) {
          setRegMessage(`❌ Server error: ${error.message}`);
        } else {
          setRegMessage("❌ " + error.message);
        }
      } finally {
        setIsRegistering(false);
      }
    };

    // ✅ FIX: Logout clears every trace, including the keepLoggedIn flag,
    // so a refresh after logout will never auto-login again.
    const handleLogout = () => {
      setIsSuccess(false);
      setUserData(null);
      setEmail("");
      setPassword("");
      setApiMessage("");
      setLoginFailed(false);
      setShowDropdown(false);
      localStorage.removeItem("userKey");
      localStorage.removeItem("userData");
      localStorage.removeItem("keepLoggedIn");
      localStorage.removeItem("activeUserSession");
    };

    return (
      <>
        <style>{`
          @import url('https://fonts.googleapis.com/css2?family=Poppins:wght=300;400;600&display=swap');
          @import url('https://unpkg.com/boxicons@2.1.4/css/boxicons.min.css');

          .auth-scope * {
            box-sizing: border-box;
            font-family: "Poppins", sans-serif;
          }

          /* ✅ FIX: page-wrapper no longer forces full-viewport height/background —
            this component now lives inside a modal, not its own full page. */
          .auth-scope.page-wrapper {
            display: flex;
            justify-content: center;
            align-items: center;
            min-height: auto;
            background: transparent;
          }

          /* ✅ FIX: container is now fluid + capped, instead of a fixed 1000px
            box designed for a full page. Fits inside a ~480px modal cleanly
            and shrinks further on small screens. */
          .container {
            position: relative;
            width: 100%;
            max-width: 420px;
            min-height: 480px;
            background: #fff;
            margin: 0 auto;
            border-radius: 16px;
            box-shadow: none;
            overflow: hidden;
          }

          .container h1 { font-size: 30px; margin: 0 0 6px; }
          .container p { font-size: 14px; margin: 10px 0; color: #6b7280; }

          form { width: 100%; }

          /* ✅ FIX: form-box is no longer a 50%-width absolutely positioned
            sliding panel. It's a normal full-width block; login/register
            visibility is now toggled with display, and switching between
            them is handled by a text link instead of the toggle-box slider. */
          .form-box {
            position: relative;
            width: 100%;
            height: auto;
            background: #fff;
            display: none;
            flex-direction: column;
            align-items: center;
            color: #333;
            text-align: center;
            padding: 30px 25px;
          }

          .form-box.login { display: flex; }
          .container.active .form-box.login { display: none; }
          .container.active .form-box.register { display: flex; }

          .input-box {
            position: relative;
            width: 100%;
            margin: 14px 0;
          }

          .input-box input {
            width: 100%;
            padding: 13px 50px 13px 20px;
            background: #eee;
            border-radius: 8px;
            border: none;
            outline: none;
            font-size: 16px;
            color: #333;
            font-weight: 500;
            transition: 0.3s;
          }

          .input-box input:focus {
            background: #fff;
            border: 2px solid #0a2a6e;
          }

          .input-box input:disabled {
            opacity: 0.6;
            cursor: not-allowed;
          }

          .input-box i {
            position: absolute;
            right: 20px;
            top: 50%;
            transform: translateY(-50%);
            font-size: 20px;
          }

          .btn {
            width: 100%;
            height: 48px;
            background: #0a2a6e;
            border-radius: 8px;
            border: none;
            cursor: pointer;
            font-size: 16px;
            color: #fff;
            font-weight: 600;
            margin-top: 10px;
            transition: 0.3s;
          }

          .btn:hover {
            background: #082050;
            transform: translateY(-2px);
            box-shadow: 0 5px 15px rgba(10, 42, 110, 0.3);
          }

          .btn:active {
            transform: translateY(0);
          }

          .btn:disabled {
            background: #97a3c4;
            cursor: not-allowed;
            transform: none;
            box-shadow: none;
          }

          .btn.secondary {
            background: #97a3c4;
          }

          .btn.secondary:hover {
            background: #7d8ab0;
          }

          .social-icons {
            display: flex;
            justify-content: center;
            margin-top: 15px;
          }

          .social-icons a {
            display: inline-flex;
            padding: 10px;
            border: 2px solid #ccc;
            border-radius: 8px;
            font-size: 24px;
            color: #333;
            margin: 0 8px;
            text-decoration: none;
            transition: 0.3s;
          }

          .social-icons a:hover {
            border-color: #0a2a6e;
            color: #0a2a6e;
          }

          /* ✅ FIX: switch-link replaces the old sliding toggle-box —
            simple text link under each form instead of a fixed-width
            animated slider that doesn't fit a modal. */
          .switch-link {
            margin-top: 16px;
            font-size: 13.5px;
            color: #6b7280;
          }

          .switch-link span {
            color: #0a2a6e;
            font-weight: 600;
            cursor: pointer;
          }

          .switch-link span:hover {
            text-decoration: underline;
          }

          .msg-text {
            font-weight: 600;
            margin-top: 15px !important;
            font-size: 14px;
            min-height: 20px;
          }

          .msg-text.success {
            color: #4caf50;
          }

          .msg-text.error {
            color: #d32f2f;
          }

          .profile-wrapper {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            min-height: 300px;
            position: relative;
          }

          .profile-container {
            position: relative;
            cursor: pointer;
            text-align: center;
          }

          .avatar-icon {
            font-size: 70px;
            color: #0a2a6e;
            background: #eee;
            padding: 15px;
            border-radius: 50%;
            box-shadow: 0 4px 15px rgba(0,0,0,0.1);
            transition: 0.3s;
          }

          .avatar-icon:hover {
            transform: scale(1.05);
          }

          .dropdown-menu {
            position: absolute;
            top: 120px;
            left: 50%;
            transform: translateX(-50%);
            background: #fff;
            width: 260px;
            max-width: 90vw;
            border-radius: 15px;
            box-shadow: 0 10px 25px rgba(0,0,0,0.15);
            padding: 20px;
            text-align: left;
            z-index: 10;
            border: 1px solid #eee;
            animation: slideDown 0.3s ease-out;
          }

          @keyframes slideDown {
            from {
              opacity: 0;
              transform: translateX(-50%) translateY(-10px);
            }
            to {
              opacity: 1;
              transform: translateX(-50%) translateY(0);
            }
          }

          .dropdown-menu h3 {
            font-size: 18px;
            color: #0a2a6e;
            margin-bottom: 5px;
            border-bottom: 2px solid #f0f0f0;
            padding-bottom: 8px;
          }

          .dropdown-menu p {
            font-size: 13.5px;
            color: #555;
            margin: 8px 0 !important;
            word-break: break-all;
          }

          .dropdown-menu p i {
            margin-right: 8px;
            color: #0a2a6e;
          }

          .logout-btn {
            width: 100%;
            background: #d32f2f;
            margin-top: 15px;
            height: 40px;
          }
          
          .logout-btn:hover {
            background: #b71c1c;
            transform: translateY(-2px);
          }

          .login-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(10, 20, 45, 0.75);
            backdrop-filter: blur(4px);
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            z-index: 999;
            animation: fadeIn 0.25s ease-out;
            padding: 16px;
          }

          @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }

          .overlay-card {
            background: #fff;
            border-radius: 24px;
            padding: 36px 40px;
            text-align: center;
            box-shadow: 0 20px 50px rgba(0,0,0,0.3);
            max-width: 320px;
            width: 100%;
            animation: popIn 0.3s ease-out;
          }

          @keyframes popIn {
            from { transform: scale(0.85); opacity: 0; }
            to { transform: scale(1); opacity: 1; }
          }

          .overlay-text {
            margin-top: 20px !important;
            font-size: 15px;
            font-weight: 600;
            color: #0a2a6e;
            line-height: 1.5;
          }

          .overlay-card.error .overlay-text {
            color: #d32f2f;
          }

          .robot {
            width: 130px;
            height: 150px;
            margin: 0 auto;
            position: relative;
          }

          .robot-antenna {
            width: 4px;
            height: 20px;
            background: #0a2a6e;
            margin: 0 auto;
            border-radius: 2px;
            position: relative;
          }

          .robot-antenna::before {
            content: '';
            position: absolute;
            top: -8px;
            left: 50%;
            transform: translateX(-50%);
            width: 10px;
            height: 10px;
            background: #4dc3ff;
            border-radius: 50%;
            box-shadow: 0 0 10px #4dc3ff;
            animation: pulseAntenna 1s infinite ease-in-out;
          }

          @keyframes pulseAntenna {
            0%, 100% { opacity: 1; transform: translateX(-50%) scale(1); }
            50% { opacity: 0.5; transform: translateX(-50%) scale(0.8); }
          }

          .robot-head {
            width: 110px;
            height: 80px;
            background: linear-gradient(145deg, #ffffff, #e8ecf5);
            border-radius: 45px 45px 40px 40px;
            margin: 0 auto;
            position: relative;
            box-shadow: inset 0 -4px 8px rgba(0,0,0,0.08), 0 8px 15px rgba(0,0,0,0.12);
            border: 2px solid #dfe4f0;
          }

          .robot-eyes {
            display: flex;
            justify-content: center;
            gap: 16px;
            padding-top: 24px;
          }

          .robot-eye {
            width: 26px;
            height: 26px;
            border-radius: 50%;
            background: #0d1b3d;
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: 0 0 12px rgba(77, 195, 255, 0.6);
          }

          .robot-eye::after {
            content: '';
            width: 12px;
            height: 12px;
            border-radius: 50%;
            background: #4dc3ff;
            box-shadow: 0 0 8px #4dc3ff;
            animation: blink 2.5s infinite;
          }

          @keyframes blink {
            0%, 90%, 100% { transform: scaleY(1); }
            95% { transform: scaleY(0.1); }
          }

          .robot.sad .robot-eye {
            background: transparent;
            box-shadow: none;
            border-radius: 0;
            height: 12px;
            align-items: flex-start;
          }

          .robot.sad .robot-eye::after {
            content: '';
            width: 20px;
            height: 20px;
            border-radius: 50%;
            border: 3px solid #ff5252;
            border-top-color: transparent;
            border-left-color: transparent;
            border-right-color: transparent;
            background: transparent;
            box-shadow: none;
            animation: none;
            transform: rotate(180deg);
            margin-top: -4px;
          }

          .robot-body {
            width: 90px;
            height: 60px;
            background: linear-gradient(145deg, #ffffff, #e8ecf5);
            border-radius: 30px;
            margin: 6px auto 0;
            position: relative;
            box-shadow: inset 0 -4px 8px rgba(0,0,0,0.08), 0 6px 12px rgba(0,0,0,0.1);
            border: 2px solid #dfe4f0;
          }

          .robot-body-light {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: #4dc3ff;
            position: absolute;
            top: 12px;
            left: 50%;
            transform: translateX(-50%);
            box-shadow: 0 0 8px #4dc3ff;
            animation: pulseAntenna 1s infinite ease-in-out;
          }

          .robot.sad .robot-body-light {
            background: #ff5252;
            box-shadow: 0 0 8px #ff5252;
            animation: none;
          }

          .robot-arm {
            position: absolute;
            top: 90px;
            width: 12px;
            height: 45px;
            background: linear-gradient(145deg, #d8dde8, #b8c0d4);
            border-radius: 8px;
          }

          .robot-arm.left {
            left: -6px;
            transform-origin: top center;
            animation: wave 1.2s infinite ease-in-out;
          }

          .robot-arm.right {
            right: -6px;
          }

          .robot.sad .robot-arm.left {
            animation: none;
            transform: rotate(20deg);
          }

          @keyframes wave {
            0%, 100% { transform: rotate(-15deg); }
            50% { transform: rotate(15deg); }
          }

          .spinner-dots {
            display: flex;
            justify-content: center;
            gap: 6px;
            margin-top: 14px;
          }

          .spinner-dots span {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: #0a2a6e;
            animation: dotBounce 1.2s infinite ease-in-out;
          }

          .spinner-dots span:nth-child(2) { animation-delay: 0.2s; }
          .spinner-dots span:nth-child(3) { animation-delay: 0.4s; }

          @keyframes dotBounce {
            0%, 80%, 100% { transform: translateY(0); opacity: 0.5; }
            40% { transform: translateY(-8px); opacity: 1; }
          }

          .overlay-close-btn {
            margin-top: 20px;
            background: transparent;
            border: none;
            color: #0a2a6e;
            font-weight: 600;
            font-size: 13.5px;
            cursor: pointer;
            text-decoration: underline;
          }

          .modal-close-icon {
            position: absolute;
            top: 12px;
            right: 12px;
            width: 34px;
            height: 34px;
            border-radius: 50%;
            background: #f1f2f6;
            border: none;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            font-size: 20px;
            color: #333;
            z-index: 5;
            transition: 0.2s;
          }

          .modal-close-icon:hover {
            background: #e0e2ea;
            color: #d32f2f;
            transform: rotate(90deg);
          }

          /* ✅ Responsive tightening for small screens */
          @media (max-width: 480px) {
            .container { max-width: 100%; border-radius: 12px; min-height: 420px; }
            .form-box { padding: 26px 18px; }
            .container h1 { font-size: 24px; }
            .overlay-card { padding: 28px 22px; }
          }
        `}</style>

        {isLoading && (
          <div className="login-overlay">
            <div className="overlay-card">
              <div className="robot">
                <div className="robot-antenna"></div>
                <div className="robot-head">
                  <div className="robot-eyes">
                    <div className="robot-eye"></div>
                    <div className="robot-eye"></div>
                  </div>
                </div>
                <div className="robot-body">
                  <div className="robot-body-light"></div>
                </div>
                <div className="robot-arm left"></div>
                <div className="robot-arm right"></div>
              </div>
              <p className="overlay-text">
                Please wait, your Login Password is checking...
              </p>
              <div className="spinner-dots">
                <span></span><span></span><span></span>
              </div>
            </div>
          </div>
        )}

        {loginFailed && !isLoading && (
          <div className="login-overlay">
            <div className="overlay-card error">
              <div className="robot sad">
                <div className="robot-antenna"></div>
                <div className="robot-head">
                  <div className="robot-eyes">
                    <div className="robot-eye"></div>
                    <div className="robot-eye"></div>
                  </div>
                </div>
                <div className="robot-body">
                  <div className="robot-body-light"></div>
                </div>
                <div className="robot-arm left"></div>
                <div className="robot-arm right"></div>
              </div>
              <p className="overlay-text">
                Sorry, your Email or Password is incorrect
              </p>
              <button className="overlay-close-btn" onClick={() => setLoginFailed(false)}>
                Try Again
              </button>
            </div>
          </div>
        )}

        {isRegistering && (
          <div className="login-overlay">
            <div className="overlay-card">
              <div className="robot">
                <div className="robot-antenna"></div>
                <div className="robot-head">
                  <div className="robot-eyes">
                    <div className="robot-eye"></div>
                    <div className="robot-eye"></div>
                  </div>
                </div>
                <div className="robot-body">
                  <div className="robot-body-light"></div>
                </div>
                <div className="robot-arm left"></div>
                <div className="robot-arm right"></div>
              </div>
              <p className="overlay-text">
                Please wait, creating your account...
              </p>
              <div className="spinner-dots">
                <span></span><span></span><span></span>
              </div>
            </div>
          </div>
        )}

        {regSuccess && !isRegistering && (
          <div className="login-overlay">
            <div className="overlay-card">
              <div className="robot">
                <div className="robot-antenna"></div>
                <div className="robot-head">
                  <div className="robot-eyes">
                    <div className="robot-eye"></div>
                    <div className="robot-eye"></div>
                  </div>
                </div>
                <div className="robot-body">
                  <div className="robot-body-light"></div>
                </div>
                <div className="robot-arm left"></div>
                <div className="robot-arm right"></div>
              </div>
              <p className="overlay-text" style={{ color: '#4caf50' }}>
                🎉 Registration Successful! Redirecting to login...
              </p>
            </div>
          </div>
        )}

        {regFailed && !isRegistering && (
          <div className="login-overlay">
            <div className="overlay-card error">
              <div className="robot sad">
                <div className="robot-antenna"></div>
                <div className="robot-head">
                  <div className="robot-eyes">
                    <div className="robot-eye"></div>
                    <div className="robot-eye"></div>
                  </div>
                </div>
                <div className="robot-body">
                  <div className="robot-body-light"></div>
                </div>
                <div className="robot-arm left"></div>
                <div className="robot-arm right"></div>
              </div>
              <p className="overlay-text">
                {regMessage.replace("❌ ", "") || "Registration failed. Please try again."}
              </p>
              <button className="overlay-close-btn" onClick={() => setRegFailed(false)}>
                Try Again
              </button>
            </div>
          </div>
        )}

        {/* ✅ NEW: Logout confirmation popup */}
        {showLogoutConfirm && (
          <div className="login-overlay">
            <div className="overlay-card">
              <p className="overlay-text" style={{ marginTop: 0 }}>
                Are you sure you want to logout?
              </p>
              <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
                <button
                  type="button"
                  className="btn secondary"
                  style={{ marginTop: 0 }}
                  onClick={() => setShowLogoutConfirm(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn logout-btn"
                  style={{ marginTop: 0 }}
                  onClick={() => {
                    setShowLogoutConfirm(false);
                    handleLogout();
                  }}
                >
                  Yes, Logout
                </button>
              </div>
            </div>
          </div>
        )}

        <div className={`container ${isActive ? "active" : ""}`}>
          {isSuccess ? (
            <div className="profile-wrapper">
              <div className="profile-container" onClick={() => setShowDropdown(!showDropdown)}>
                <i className="bx bxs-user-circle avatar-icon"></i>
                <p style={{ fontWeight: '600', marginTop: '10px', color: '#0a2a6e' }}>
                  Hi, {userData?.UserName || "User"} 👋
                </p>

                {showDropdown && (
                  <div className="dropdown-menu" onClick={(e) => e.stopPropagation()}>
                    <h3>Account Details</h3>
                    <p><i className="bx bxs-user"></i> <b>Name:</b> {userData?.UserName || "N/A"}</p>
                    <p><i className="bx bxs-envelope"></i> <b>Email:</b> {email}</p>
                    <p><i className="bx bxs-key"></i> <b>Status:</b> {userData?.UserStatus}</p>
                    <p><i className="bx bxs-id-card"></i> <b>Account:</b> {userData?.AccountNo || "11"}</p>
                    <p><i className="bx bxs-key"></i> <b>Key:</b> {userData?.UserKey?.substring(0, 20)}...</p>

                    {/* ✅ FIX: logout button now opens confirmation popup instead of logging out immediately */}
                    <button className="btn logout-btn" onClick={() => setShowLogoutConfirm(true)}>
                      <i className="bx bx-log-out" style={{ marginRight: '5px' }}></i> Logout
                    </button>
                  </div>
                )}
              </div>
            </div>
          ) : (
            <>
              <div className="form-box login">
                <button type="button" className="modal-close-icon" onClick={handleClose} aria-label="Close">
                  <i className="bx bx-x"></i>
                </button>
                <form onSubmit={handleLogin}>
                  <h1>Login</h1>
                  <div className="input-box">
                    <input
                      type="email"
                      placeholder="Email"
                      required
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      disabled={isLoading}
                    />
                    <i className="bx bxs-user"></i>
                  </div>
                  <div className="input-box">
                    <input
                      type="password"
                      placeholder="Password"
                      required
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      disabled={isLoading}
                    />
                    <i className="bx bxs-lock-alt"></i>
                  </div>
                  <button type="submit" className="btn" disabled={isLoading}>
                    {isLoading ? "Checking..." : "Login"}
                  </button>

                  {apiMessage && !isLoading && (
                    <p className={`msg-text ${apiMessage.includes("✅") ? "success" : "error"}`}>
                      {apiMessage}
                    </p>
                  )}

                  {/* ✅ replaces the old sliding toggle-box register panel */}
                  <p className="switch-link">
                    Don't have an account?{" "}
                    <span onClick={() => setIsActive(true)}>Register</span>
                  </p>
                </form>
              </div>

              <div className="form-box register">
                <button type="button" className="modal-close-icon" onClick={handleClose} aria-label="Close">
                  <i className="bx bx-x"></i>
                </button>
                <form onSubmit={handleRegister}>
                  <h1>Registration</h1>
                  <div className="input-box">
                    <input
                      type="text"
                      placeholder="Username"
                      required
                      value={regName}
                      onChange={(e) => setRegName(e.target.value)}
                      disabled={isRegistering}
                    />
                    <i className="bx bxs-user"></i>
                  </div>
                  <div className="input-box">
                    <input
                      type="email"
                      placeholder="Email"
                      required
                      value={regEmail}
                      onChange={(e) => setRegEmail(e.target.value)}
                      disabled={isRegistering}
                    />
                    <i className="bx bxs-envelope"></i>
                  </div>
                  <div className="input-box">
                    <input
                      type="tel"
                      placeholder="Mobile Number"
                      required
                      pattern="[0-9]{10}"
                      maxLength={10}
                      value={regMobile}
                      onChange={(e) => setRegMobile(e.target.value.replace(/\D/g, ""))}
                      disabled={isRegistering}
                    />
                    <i className="bx bxs-phone"></i>
                  </div>
                  <div className="input-box">
                    <input
                      type="password"
                      placeholder="Password"
                      required
                      value={regPassword}
                      onChange={(e) => setRegPassword(e.target.value)}
                      disabled={isRegistering}
                    />
                    <i className="bx bxs-lock-alt"></i>
                  </div>
                  <button type="submit" className="btn" disabled={isRegistering}>
                    {isRegistering ? "Registering..." : "Register"}
                  </button>

                  {regMessage && !isRegistering && (
                    <p className={`msg-text ${regMessage.includes("✅") ? "success" : "error"}`}>
                      {regMessage}
                    </p>
                  )}

                  <p>or register with social platforms</p>
                  <div className="social-icons">
                    <a href="#"><i className="bx bxl-google"></i></a>
                    <a href="#"><i className="bx bxl-facebook"></i></a>
                    <a href="#"><i className="bx bxl-github"></i></a>
                    <a href="#"><i className="bx bxl-linkedin"></i></a>
                  </div>
                  <p className="switch-link">
                    Already have an account?{" "}
                    <span onClick={() => setIsActive(false)}>Login</span>
                  </p>
                </form>
              </div>
            </>
          )}
        </div>
      </>
    );
  };

  export default AuthPage;